import { EntityType } from '@frontend/common';
import { SettingClient } from '@frontend/setting/api';
import { SettingKey } from '@frontend/setting/types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useKioskNavigate } from '../../utils/kiosk-navigation';
import { LicenseNavigationCardProps } from './license-navigation-card.component';

interface ViewProps {
    onNavigate: () => void;
}

const useLicenseNavigationCard = (props: LicenseNavigationCardProps): ViewProps => {
    const navigate = useKioskNavigate();
    const location = useLocation();
    const [wizard, setWizard] = useState<string | null>(null);

    useEffect(() => {
        if (props.functionality.wizard_id) setWizard(props.functionality.wizard_id);
        else
            SettingClient.fetchSettings({ entity_id: props.functionality.id, entity_type: EntityType.FUNCTIONALITY }).then((settings) => {
                const setting = settings.results.find((s) => s.key === SettingKey.WIZARD_ID);
                if (setting && typeof setting.value === 'string') {
                    setWizard(setting.value);
                }
            });
    }, []);

    const onNavigate = () => {
        if (!wizard) {
            navigate(`/${props.functionality.application}/${props.functionality.feature}`);
        } else {
            navigate(`wizard/${props.functionality.id}/${wizard}?from=${encodeURIComponent(location.pathname + location.search)}`);
        }
    };
    return {
        onNavigate
    };
};

export default useLicenseNavigationCard;
